import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import RequestPortal from './personalstuff/RequestPortal';
import PurchasedContent from './personalstuff/PurchasedContent';
import TrackPurchases from './personalstuff/TrackPurchases';
import './CustomBuild.css';

const CustomBuild = () => {
    const location = useLocation();
    
    // Check for stored tab preference on mount
    const [activeTab, setActiveTab] = useState(() => {
        // First check session storage
        const storedTab = sessionStorage.getItem('customBuildTab');
        if (storedTab) {
            sessionStorage.removeItem('customBuildTab'); // Clear it after use
            return storedTab;
        }
        // Default to 'requests' if no stored preference
        return 'requests';
    });

    // Listen for state changes
    useEffect(() => {
        if (location.state?.targetTab) {
            setActiveTab(location.state.targetTab);
            // Clear the state after using it
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    return (
        <div className="custom-build-container">
            <h2>Custom Build</h2>
            
            <div className="custom-build-tabs">
                <button 
                    className={`tab-button ${activeTab === 'requests' ? 'active' : ''}`}
                    onClick={() => setActiveTab('requests')}
                >
                    Request Portal
                </button>
                <button 
                    className={`tab-button ${activeTab === 'tracking' ? 'active' : ''}`}
                    onClick={() => setActiveTab('tracking')}
                >
                    Track Orders
                </button>
                <button 
                    className={`tab-button ${activeTab === 'purchased' ? 'active' : ''}`}
                    onClick={() => setActiveTab('purchased')}
                >
                    Purchased Content
                </button>
            </div>
            
            <div className="custom-build-content">
                {activeTab === 'requests' ? (
                    <RequestPortal />
                ) : activeTab === 'tracking' ? (
                    <TrackPurchases />
                ) : (
                    <PurchasedContent />
                )}
            </div>
        </div>
    );
};

export default CustomBuild; 